module.exports = __webpack_public_path__ + "static/fonts/sjis_sp_setofont.634dadea.ttf";